/**
 * @fileoverview POST handler for the "/apps/multi_language_settings/add_locale" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appsMultiLanguageSettingsAddLocaleCacheKeys } from "./constants";
import type {
  PostAppsMultiLanguageSettingsAddLocaleProps,
  AppsMultiLanguageSettingsAddLocaleResult,
  AddLocaleErrors,
} from "./types";

export const postAppsMultiLanguageSettingsAddLocale = reactQueryMutationAdapter(
  appsMultiLanguageSettingsAddLocaleCacheKeys,
  createMutationFetcherFunctionWithShadowError<AddLocaleErrors>()(
    (props: PostAppsMultiLanguageSettingsAddLocaleProps): Promise<AppsMultiLanguageSettingsAddLocaleResult> => {
      return fetch("/apps/multi_language_settings/add_locale", "POST", props, undefined, {
        propagateFetchRequestError: false,
      });
    }
  )
);
